<h2 *ngIf="error" class="text-danger">Error</h2>
<h2 *ngIf="!error && !loaded" class="spinner-border spinner-border-lg"></h2>
<div *ngIf="!error && loaded">
  <div *ngIf="dropdownList?.length > 0">
    Group by:
    <ng-multiselect-dropdown
      [settings]="dropdownSettings"
      [placeholder]="'Select a grouping aggregation'"
      [data]="dropdownList"
      [(ngModel)]="selectedItems"
      (onSelect)="onItemSelected($event)"
      (onDeSelect)="onItemDeselected($event)"
    ></ng-multiselect-dropdown>
  </div>
  <canvas
    baseChart
    width="400"
    height="250"
    [datasets]="data"
    [labels]="labels"
    [options]="options"
    [colors]="colors"
    [legend]="legend"
    [chartType]="type"
  >
  </canvas>
</div>
